import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { ClientIcon } from '@/components/icons/Client';
import { getBrandfetchLogoUrl } from '@/utils/clientLogo';

export const ClientBrandIcon = ({
	domain,
	bgColor = '#34495E',
	width = '24px',
	height = '24px',
	alt,
	sx = {},
	fallbackIcon,
	...props
}) => {
	const [hasLogoError, setHasLogoError] = useState(false);
	const logoUrl = getBrandfetchLogoUrl(domain);

	useEffect(() => {
		setHasLogoError(false);
	}, [domain]);

	if (!logoUrl || hasLogoError) {
		return (
			fallbackIcon ?? (
				<ClientIcon
					bgColor={bgColor}
					width={width}
					height={height}
					{...props}
				/>
			)
		);
	}

	return (
		<Box
			{...props}
			component='span'
			sx={{
				alignItems: 'center',
				backgroundColor: 'common.white',
				border: '1px solid',
				borderColor: 'divider',
				borderRadius: 2,
				display: 'inline-flex',
				flex: '0 0 auto',
				height,
				justifyContent: 'center',
				overflow: 'hidden',
				width,
				...sx,
			}}
		>
			<Box
				component='img'
				alt={alt ?? `${domain} logo`}
				src={logoUrl}
				onError={() => setHasLogoError(true)}
				referrerPolicy='strict-origin-when-cross-origin'
				sx={{
					display: 'block',
					height: '100%',
					objectFit: 'cover',
					width: '100%',
				}}
			/>
		</Box>
	);
};